export const LEAD_SOURCES = ['Facebook Ads', 'WhatsApp Ads', 'Website', 'Instagram', 'TikTok', 'Google Search', 'Referral', 'Organic', 'Manual Entry'];
export const LEAD_COURSES = ['Forex', 'Crypto', 'Stock Market', 'Home Decoration', 'Other'];
export const LEAD_DATE_TYPES = [
  { value: 'createdAt', label: 'Created date' },
  { value: 'updatedAt', label: 'Updated date' },
  { value: 'convertedAt', label: 'Converted date' }
];
